import {Banner, Dialog} from '@primer/react'
import {useIsLoading} from '../contexts/IsLoadingContext'
import {PreviewsTable} from './previews-table'
import {EnforcementPicker} from './enforcement-picker'
import {PreviewsCountSummary} from './previews-count-summary'
import type {EditablePreview} from '../types'
import {useButton} from '../contexts/ButtonContext'

type SelectionDialogProps = {
  previews: EditablePreview[]
  errorMessage: string | null
  isValid?: boolean
  createButtonRef: React.RefObject<HTMLButtonElement | null>
  onCancel(): void
  onSelection(): void
}

export function SelectionDialog({
  previews,
  errorMessage,
  isValid,
  createButtonRef,
  onCancel,
  onSelection,
}: SelectionDialogProps) {
  const {buttonRef: returnFocusRef} = useButton()
  const isLoading = useIsLoading()

  return (
    <Dialog
      title="Review import"
      width="large"
      height="large"
      returnFocusRef={returnFocusRef}
      onClose={onCancel}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Cancel',
          onClick: onCancel,
        },
        {
          buttonType: 'primary',
          content: 'Create rulesets',
          disabled: !isValid,
          loading: isLoading,
          onClick: onSelection,
          ref: createButtonRef,
        },
      ]}
    >
      <Dialog.Body>
        <div className="d-flex flex-column gap-3">
          {errorMessage && (
            <Banner title="Error" hideTitle variant="critical">
              <Banner.Description>{errorMessage}</Banner.Description>
            </Banner>
          )}
          <PreviewsCountSummary />
          <EnforcementPicker />
          <PreviewsTable previews={previews} />
        </div>
      </Dialog.Body>
    </Dialog>
  )
}
